// src/components/preferences/IndustriesPreferenceEditor.tsx
/**
 * Editor for preferred industries (top-level field)
 * ⚠️ Note: Industries is at preference_data.industries, not under company
 */
import React from 'react';
import {
  IonItem,
  IonLabel,
  IonInput,
  IonList,
  IonChip,
  IonIcon,
  IonButton,
} from '@ionic/react';
import { closeCircle } from 'ionicons/icons';
import './PreferenceEditor.css';

interface IndustriesPreferenceEditorProps {
  data: string[]; // Just an array of industries
  onChange: (data: string[]) => void;
}

const IndustriesPreferenceEditor: React.FC<IndustriesPreferenceEditorProps> = ({ data, onChange }) => {
  const [newIndustry, setNewIndustry] = React.useState('');

  const handleAddIndustry = () => {
    if (newIndustry.trim()) {
      onChange([...(data || []), newIndustry.trim()]);
      setNewIndustry('');
    }
  };

  const handleRemoveIndustry = (index: number) => {
    onChange((data || []).filter((_, i) => i !== index));
  };

  return (
    <IonList className="preference-editor-list">
      <IonItem>
        <IonLabel position="stacked">Preferred Industries</IonLabel>
        <div className="chip-input-container">
          {data && data.length > 0 && (
            <div className="chip-list">
              {data.map((industry, index) => (
                <IonChip key={index} color="primary">
                  {industry}
                  <IonIcon
                    icon={closeCircle}
                    onClick={() => handleRemoveIndustry(index)}
                  />
                </IonChip>
              ))}
            </div>
          )}
          <div className="chip-input">
            <IonInput
              value={newIndustry}
              placeholder="e.g., FinTech, HealthTech, E-commerce, B2B SaaS"
              onIonChange={(e) => setNewIndustry(e.detail.value || '')}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleAddIndustry();
                }
              }}
            />
            <IonButton onClick={handleAddIndustry} size="small">
              Add
            </IonButton>
          </div>
        </div>
      </IonItem>
    </IonList>
  );
};

export default IndustriesPreferenceEditor;
